import { ACTION_GET_USER } from './action-types';
import { FALLBACK_GET_USER_STATE } from '../reducers/get-user';

export default function getUser() {
  return function (dispatch) {
    return fetch('/session.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: 'action=getSession'
      })
      .then(response => {
        return response.json()
      })
      .then(json => {
        dispatch({ type: ACTION_GET_USER, payload: json });
      })
      .catch(err => {
        dispatch({ type: ACTION_GET_USER, payload: FALLBACK_GET_USER_STATE });

        console.log('Error logging user:', err)
      });
  };
}

